import { render, staticRenderFns } from "./TVTestCard.vue?vue&type=template&id=6eafbd22&"
import script from "./TVTestCard.vue?vue&type=script&lang=js&"
export * from "./TVTestCard.vue?vue&type=script&lang=js&"
import style0 from "./TVTestCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports